import Typography from "@mui/material/Typography"

import Column from "../../../common/components/Column"
import Row from "../../../common/components/Row"

/**
 * Status label and value (chip / text) on one tight row.
 */
export default function SettingsConnectionStatusRow({ children }) {
  return (
    <Row
      sx={{
        alignItems: "center",
        gap: 0.75,
        flexWrap: "wrap",
        ml: 2,
        width: (theme) => `calc(100% - ${theme.spacing(2)})`,
      }}
    >
      <Typography
        component="span"
        variant="body1"
        sx={{
          flexShrink: 0,
          lineHeight: 1.5,
        }}
      >
        Status:
      </Typography>
      <Column
        sx={{
          gap: 0.75,
          flex: 1,
          minWidth: 0,
          alignItems: "flex-start",
        }}
      >
        {children}
      </Column>
    </Row>
  )
}
